import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { getLocalStorageValue } from 'config/helper';

import { resetSearch } from "redux/actions";
import "./details.scss";
import { getStoreDetailsHistory } from "redux/actions";

const Details = () => {
  const dispatch = useDispatch();
  const clientId = getLocalStorageValue("RSAclient-id");
  const { currentStoreID } = useSelector(({ store }) => store);
  const storeId = currentStoreID || getLocalStorageValue("selected-store-id");

  const { storDetailsData } = useSelector(({ storehistory }) => storehistory);

  useEffect(() => {
    dispatch(resetSearch());
  }, [dispatch]); // eslint-disable-line

  useEffect(() => {
    const body = {
      RSAClientId: clientId,
      ClientStoreId: +storeId || 1,
    };
    dispatch(getStoreDetailsHistory(body));
  }, [dispatch, storeId]); // eslint-disable-line

  return (
    <>
      <div className="container">
        {storDetailsData &&
          storDetailsData.length > 0 &&
          storDetailsData.map((storeDetail, index) => {
            return (
              <div className="grid-flex-detail" key={index}>
                <div
                  className="col col-image location-img-responsive"
                  style={{ backgroundImage: `url(${storeDetail.image})` }}
                ></div>
                <div
                  className={`col col-text-detail ${index % 2 === 1 ? "col-left" : ""
                    }`}
                >
                  <div className="Align-item">
                    <h1>{storeDetail.history_title}</h1>
                    <p>{storeDetail.short_description}</p>
                  </div>
                </div>
              </div>
            );
          })}

        {/* <div className="grid-flex">
          <div className="col col-image" style={{ backgroundImage: `URL(https://s3-us-west-2.amazonaws.com/s.cdpn.io/280406/seattle-library-sm.jpg)` }}>
            &nbsp;
          </div>
          <div className="col col-text col-left">

            <div className="Aligner-item">
              <h1>Store Highlights</h1>

              <p>&ldquo;  Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,
                when an unknown printer took a galley of type and scrambled it to make a type specimen book.
                It has survived not only five centuries, but also the leap into electronic typesetting,
                remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets
                containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker
                including versions of Lorem Ipsum
              </p>
            </div>
          </div>
        </div> */}
      </div>
    </>
  );
};
export default Details;
